var _path, _radialGradient, _path2, _radialGradient2, _path3, _path4, _path5, _path6, _radialGradient3, _path7, _ellipse, _path8, _path9, _path10, _radialGradient4, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _radialGradient5, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _circle, _path27, _path28, _path29, _path30, _linearGradient, _path31, _linearGradient2, _path32, _linearGradient3, _path33, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelfastTaxiTourWheelchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.97 42.85c-.03-.02-2.58-1.67-3.14-4.46c-.36-1.79.18-4.06.76-6.45c1.1-4.55 2.35-9.7-2.4-13.25c-5.17-3.86-11.15-.46-11.21-.43a.5.5 0 0 0-.25.44l.02 1.77c0 .24.17.44.4.49c.03.01 3.23.69 4.09 3.19c.66 1.94.62 4.18.58 6.56c-.06 3.18-.12 6.46 1.58 9.2c2.22 3.58 4.83 4.4 6.76 4.4c1.62 0 2.76-.58 2.78-.59c.16-.08.26-.24.27-.42c0-.19-.09-.35-.24-.45z",
    fill: "#312d2d"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab23570",
    cx: 79.224,
    cy: 99.207,
    r: 13.177,
    gradientTransform: "matrix(1 0 0 -1 0 130)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6 31.94c-.05.19-.09.38-.14.57l-8.72-5.87c-.08-.87-.23-1.71-.5-2.49c-.86-2.5-4.06-3.19-4.09-3.19a.503.503 0 0 1-.4-.49l-.02-1.77c0-.18.09-.34.25-.43c.06-.04 6.05-3.43 11.22.42c4.74 3.55 3.49 8.7 2.4 13.25z",
    fill: "url(#IconifyId17ecdb2904d178eab23570)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab23571",
    cx: 88.671,
    cy: 89.037,
    r: 15.836,
    gradientTransform: "matrix(1 0 0 -1 0 130)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#454140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#454140",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2 43.3c-.01.18-.11.34-.27.42c-.03.01-1.16.59-2.78.59c-1.93 0-4.54-.82-6.76-4.4c-1.7-2.74-1.64-6.02-1.58-9.19c.02-1.42.05-2.8-.08-4.08l8.72 5.87c-.52 2.18-.96 4.23-.63 5.89c.57 2.79 3.12 4.44 3.14 4.46c.15.09.24.26.24.44z",
    fill: "url(#IconifyId17ecdb2904d178eab23571)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.59 18.83c-2.37-4.24-8-7.71-12.82-7.14c-5.4.64-8.46 4.37-9.44 9.23c-.36 1.76-.38 3.53-.14 4.8c.03.15.28 1.26.28 1.6c.14 1.33-2.47 2.52-2.84 3.97c-.28 1.09 1.98 1.89 2.15 2.09c.85 1.02-.78 5.69 5.47 6.4c2.18.25 3.54-.12 4.3-.06c1.8.15 2.8 6.11 2.8 6.11l9.21-5.57s-3.07-4.51-.39-9.14c2.59-3.68 2.94-9.56 1.42-12.29z",
    fill: "#f9ddbd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.31 36.04c.87.09 1.74-.08 2.5-.59c.83-.56.31-1.25-.63-.9c-.57.21-1.36.29-2.07.13l.2 1.36z",
    fill: "#444"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.18 15.79c-2.24-3.03-6.04-5.08-10.16-5.49c-3.58-.36-8.54.28-11.72 3.12c-1.91 1.7-3.1 4.02-2.94 6.66c.1 1.59 1.68 2.41 1.68 2.41l.08-.13s.01-.02.03-.05l.14-.25c.5-.8 1.66-2.93 4.72-1.95c3.78 1.21 5.52.45 5.52.45c-1.45 2.99 1.06 6.62 1.34 7.02c.15.21.28.2.35-.01c.17-.49.5-1.36.74-1.77c.78-1.37 1.9-.81 1.91-.81c1.53.62 1.92 3.84-.72 5.59c-.06.04-.21.14-.16.47c.12.81 1.53 3.12 3.85 3.8c.31.09.58.15.83.18c1.32.15 2.08-.36 2.28-1.34c.43-2.14.93-2.74 1.65-3.64c.83-1.04 1.78-2.22 2.45-5.57c.64-3.16-.01-6.17-1.87-8.69z",
    fill: "#312d2d"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab23572",
    cx: 61.566,
    cy: 107.147,
    r: 15.616,
    gradientTransform: "matrix(1 0 0 -1 0 130)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#454140",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454140"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.18 15.79c-2.24-3.03-6.04-5.08-10.16-5.49c-3.58-.36-8.54.28-11.72 3.12c-1.91 1.7-3.1 4.02-2.94 6.66c.1 1.59 1.68 2.41 1.68 2.41l.08-.13s.01-.02.03-.05l.14-.25c.5-.8 1.66-2.93 4.72-1.95c3.78 1.21 5.52.45 5.52.45c-1.45 2.99 1.06 6.62 1.34 7.02c.15.21.28.2.35-.01c.17-.49.5-1.36.74-1.77c.78-1.37 1.9-.81 1.91-.81c1.53.62 1.92 3.84-.72 5.59c-.06.04-.21.14-.16.47c.12.81 1.53 3.12 3.85 3.8c.31.09.58.15.83.18c1.32.15 2.08-.36 2.28-1.34c.43-2.14.93-2.74 1.65-3.64c.83-1.04 1.78-2.22 2.45-5.57c.64-3.16-.01-6.17-1.87-8.69z",
    fill: "url(#IconifyId17ecdb2904d178eab23572)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-89.209 53.763 28.259)",
    cx: 53.76,
    cy: 28.26,
    rx: 1.77,
    ry: 1.15,
    fill: "#312d2d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.99 25.61c-1.15.22-1.34-.55-.91-1.1c.32-.41 1.03-.71 2.31-.32c1.21.36 1.64 1.12 1.93 1.59c.29.46.21.89-.08.9c-.39 0-1.83-1.34-3.25-1.07z",
    fill: "#454140"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.43 116.74c.6.19 1.25-.14 1.44-.74l.85-2.67c.58-1.81-.59-4.47-.59-4.47l-6.64-2.14l-6.61.05c-1.63.1-3.04 1.19-3.55 2.74l-.39 1.2c-.17.53.12 1.09.65 1.26l14.84 4.77z",
    fill: "#4568ad"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.14 67.06l-17.02 3.62l-.13 2.55l-7.94.18c-4.88.48-11.67.17-14.27 10.49l-6.89 22.59l9.85 3.43s7.9-21.46 8.4-21.43c.5.02 15.14.81 24.77-.5c9.6-1.29 3.23-20.93 3.23-20.93z",
    fill: "#7c7c7c"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab23573",
    cx: 67.56,
    cy: 75.887,
    r: 19.484,
    gradientTransform: "scale(1 -1) rotate(18.161 475.103 10.053)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#651fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#5914f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#530eeb"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.09 72.18c1.55-12.08-1.22-12.23-3.31-20.12c-1.06-4 .37-8.61 1.95-10.5c3.47-3.15 7.2-3.97 10.19-1.2c5.89 5.48 12.5 26.92 12.5 26.92c-4.71 8.68-21.33 4.9-21.33 4.9z",
    fill: "url(#IconifyId17ecdb2904d178eab23573)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M78.47 93.17h4v7.14h-4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.24 119.99l-15.98-5.19a2.216 2.216 0 0 1-1.42-2.79c.38-1.16 1.63-1.8 2.79-1.42l15.98 5.19c1.16.38 1.8 1.63 1.42 2.79a2.216 2.216 0 0 1-2.79 1.42z",
    fill: "#424242"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.54 111.63c-3.61 0-6.53 2.93-6.53 6.53c0 3.61 2.93 6.53 6.53 6.53c3.61 0 6.53-2.93 6.53-6.53c.01-3.6-2.92-6.53-6.53-6.53z",
    fill: "#78909c"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.62 59.87c-1.81 0-1.81 1.94-1.81 2.59l-.25 29.21l-32.67-1.77c-9.36 0-13.66 3.58-17.04 14.18l-4.78 13.87c-.17.5-.14 1.05.09 1.53s.64.84 1.15 1.01c.21.07.43.11.65.11c.85 0 1.61-.54 1.89-1.35l3.55-10.29c1.84.6 3.14 2.35 3.14 4.32v4.88c0 1.1.9 2 2 2s2-.9 2-2v-4.88c0-3.68-2.38-6.94-5.84-8.1c2.84-8.85 5.68-11.28 13.07-11.29l32.85 1.91c1.25 0 1.92-.14 2.63-.96c.79-.95.8-2.47.8-2.48l.38-30.19c0-2-1.13-2.3-1.81-2.3z",
    fill: "#f44336"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.52 120.33c-.99 0-1.8-.66-1.96-1.65l-.33-3.35c-.08-.53.37-1 .95-1h2.54c.57 0 1.01.45.96.97l-.12 3.39c0 .9-1.05 1.64-2.04 1.64z",
    fill: "#424242"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.97 62.84c0-2.46-1.34-2.85-3.55-2.85h-1.64c-2.31.03-2.69 1.07-3.11 2.57c-.75 2.67-2.18 16.77-1.07 20.67c.03.1.08.22.12.32l-28.96-.85c-1.73 0-3.19.63-3.77 4.09c0 0-.11.44.09 2.12c.2 1.68 1.31 2.44 2.76 2.51l38.84 1.88l-.05-.13c.06.05.1.08.1.08l.24-30.41z",
    fill: "#424242"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.79 92.15c2.22-2.9 5.67-4.56 10.02-4.35c5.04.23 8.15 3.31 9.74 5.4l3.4.07c.07-3.89.26-13.9.26-13.9c-2.54-4.26-29.74-11.62-38.87 12.08l15.45.7z",
    fill: "#212121"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.66 93.95l1.81-.56c0-2.09-.26-15.91-.26-15.91c-2.67-4.46-31.97-12.63-40.07 15.72l5.24-.02l8.37.49c2.02-4.53 7.42-7.66 13.19-7.4c8.58.4 11.72 7.68 11.72 7.68z",
    fill: "#f44336"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab23574",
    cx: 76.47,
    cy: 100.306,
    r: 1.107,
    gradientTransform: "translate(4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78909c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#617a86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546e7a"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80.47 101.41c-.61 0-1.11-.5-1.11-1.11s.5-1.11 1.11-1.11s1.11.5 1.11 1.11s-.5 1.11-1.11 1.11z",
    fill: "url(#IconifyId17ecdb2904d178eab23574)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.47 99.7c.33 0 .61.27.61.61c0 .33-.27.61-.61.61s-.61-.27-.61-.61c0-.34.28-.61.61-.61m0-1a1.609 1.609 0 1 0 0 3.22a1.609 1.609 0 1 0 0-3.22z",
    fill: "#82aec0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#82aec0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M80.47 79.6v41.42"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#82aec0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M95.11 85.66l-29.28 29.29"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#82aec0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M95.11 114.95L65.83 85.66"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#82aec0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M59.76 100.31h41.42"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.47 75.91c-13.47 0-24.39 10.92-24.39 24.39S67 124.7 80.47 124.7s24.39-10.92 24.39-24.39s-10.92-24.4-24.39-24.4zm0 44.14c-10.9 0-19.74-8.84-19.74-19.74c0-10.9 8.84-19.74 19.74-19.74c10.9 0 19.74 8.84 19.74 19.74c0 10.9-8.84 19.74-19.74 19.74z",
    fill: "#78909c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.47 83.58c9.22 0 16.73 7.5 16.73 16.73s-7.5 16.73-16.73 16.73s-16.73-7.5-16.73-16.73s7.51-16.73 16.73-16.73m0-1c-9.79 0-17.73 7.94-17.73 17.73s7.94 17.73 17.73 17.73s17.73-7.94 17.73-17.73s-7.94-17.73-17.73-17.73z",
    fill: "#546e7a"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.47,
    cy: 100.31,
    r: 4.11,
    fill: "#757575"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#757575",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M27.82 110.93l9.45 3.04"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.86 76.21s1.49.66 2.35 1.81l.07-3.51c-.96-.96-2.39-1.17-2.39-1.17l-.03 2.87z",
    fill: "#c62828"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7 91.41l-.69 2.95s-1.28.12-2.23-.66c-1.64-1.35-1.45-2.12-1.45-2.12c.45-.35 1.73-.78 1.73-.78s.72.35 1.38.49s1.26.12 1.26.12z",
    fill: "#c62828"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.54 93.59c1.51-4.89 4.89-9.53 9.79-12.21",
    opacity: 0.8,
    fill: "none",
    stroke: "#94d1e0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab23575",
    gradientUnits: "userSpaceOnUse",
    x1: 85.935,
    y1: 62.921,
    x2: 73.935,
    y2: 71.293,
    gradientTransform: "matrix(1 0 0 -1 0 130)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f9ddbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd29c"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.85 47.14l-5.16 5.54l9.88 6.89l-3.68 13.42l4.41 1.78s5.14-11.34 6.1-13.23c1.58-3.14 1.44-5.08-.53-7.32c-1.05-1.18-11.02-7.08-11.02-7.08z",
    fill: "url(#IconifyId17ecdb2904d178eab23575)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab23576",
    gradientUnits: "userSpaceOnUse",
    x1: 74.226,
    y1: 48.68,
    x2: 75.343,
    y2: 51.285,
    gradientTransform: "matrix(1 0 0 -1 0 130)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ddbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd29c"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M80.63 73.49c-.23-.18-.43-.35-.62-.51c-.39-.33-.76-.64-1.35-1.01c-.72-.44-4.15.93-4.93 1.22c-.26.1-.5.19-.72.29c-.3.13-.53.36-.63.63c-.04.05-.08.11-.12.2c-.01.04-.02.07-.02.11c0 .01-.25 1.5-.65 2.31c-.16.31-.07.84.26.96c0 0-.19.77-.33 1.16c-.17.46-.12.61-.14.82c-.04.36.1.63.36.8c.32.21.44.08.59.19s.1.29.14.5c.11.56.58.71.77.73c.62.06.8-.33.91-.33c.2.01.24.18.26.31c.06.28.36.43.64.52c.73.08 1.26-.54 1.28-.44c.08.37.72.65 1.09.5c.31-.13.5.12 2.35-2.72c.37-.5.97-1.84 1.37-3.12l.19-.61c.3-.96.03-1.94-.7-2.51z",
    fill: "url(#IconifyId17ecdb2904d178eab23576)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab23577",
    gradientUnits: "userSpaceOnUse",
    x1: 75.552,
    y1: 52.205,
    x2: 73.319,
    y2: 48.298,
    gradientTransform: "matrix(1 0 0 -1 0 130)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f9ddbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd29c"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78.94 71.88c-1.76-.67-6.6 1.02-6.72 2.61c-.03.36.46.92.9.73c0 0 0 .43.03.53c.14.54.76.57.95.6c.35.05.52.13.53.48c.01.33.23.7.52.87c.32.18.57.22.96.12c.18-.05.28.06.34.24c.08.25.28.59.49.69c.39.2.64.16.92.15c.18 0 .26.02.38.16c.09.12.08.59.39.76c1.39.73 2.2-2.24 2.73-3.97c.39-1.26-.43-3.21-2.42-3.97z",
    fill: "url(#IconifyId17ecdb2904d178eab23577)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.92 57.53l5.87-9.39l-8.35-5.22a5.54 5.54 0 0 0-7.63 1.76a5.54 5.54 0 0 0 1.76 7.63l8.35 5.22z",
    fill: "#3615af"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelfastTaxiTourWheelchair);
export default __webpack_public_path__ + "static/media/belfast-taxi-tour-wheelchair.ab733cea1ee7f6b3ce2889f446783320.svg";
export { ForwardRef as ReactComponent };